﻿/**
* DevExpress Analytics (core\internal\ajaxSetup.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { AjaxSetup } from './_ajaxSetup';
export var ajaxSetup = new AjaxSetup();
